












import {Component, Emit, Vue} from "vue-property-decorator"

@Component
export default class Dialog extends Vue {

  @Emit('close')
  onClickClose() {
  }

}
